import keyMirror from 'react-utils/keyMirror';
const portalSettingsKeys = keyMirror({
  gdprUnsubscribeLinkEnabled: null
});
export default portalSettingsKeys;